import { render, staticRenderFns } from "./DataConfig.vue?vue&type=template&id=44cf9ab0&scoped=true"
import script from "./DataConfig.vue?vue&type=script&lang=js"
export * from "./DataConfig.vue?vue&type=script&lang=js"
import style0 from "./DataConfig.vue?vue&type=style&index=0&id=44cf9ab0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44cf9ab0",
  null
  
)

export default component.exports